// extracted by mini-css-extract-plugin
export default {"singleFilter":"SingleFilter_singleFilter__BR0mJ"};